import { __awaiter } from "tslib";
/**
 * Created by wuyanbin on 2019/7/15
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { notification } from 'antd';
import { checkArrVal } from '@/shared/functions';
const initData = {
    isEditAble: false,
};
const reserveTipConfig = {
    overReserve: false,
    nearReserve: false,
    id: '',
    // 保留价价格梯度值
    reserveFixSteps: [],
    // 价格梯度值默认值
    fixStepsInit: [
        { min: 0, max: '', value: '', type: 'isMin' },
        { min: '', max: -1, value: '', type: 'isMax' },
    ],
};
export default createStore({
    state: Object.assign(Object.assign({}, initData), reserveTipConfig),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        RESET_STATE(state) {
            return Object.assign({}, initData);
        },
    },
    effects: {
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        handleChangeReserve(payload, { state, update }) {
            this.SET_STATE({
                [payload.type]: payload.value,
            });
        },
        toggleEditAble(payload, { state }) {
            this.SET_STATE({
                isEditAble: !state.isEditAble,
            });
        },
        // 查询规则
        getReserveTipsRule(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield Api.auction.getReserveTipsRule(payload).then((res) => {
                    if (res) {
                        this.SET_STATE({
                            id: res.id,
                            overReserve: res.basePriceRemind === 1,
                            nearReserve: res.nearBasePriceRemind === 1,
                            reserveFixSteps: res.nearBasePriceStep && res.nearBasePriceStep.length > 0 ? res.nearBasePriceStep : state.fixStepsInit,
                            isEditAble: false,
                        });
                    }
                });
            });
        },
        // 保存
        saveReserveTipsRule(payload, { state, rootState, update }) {
            const tempFixSteps = rootState.priceGradient.priceGradientSteps;
            if (state.nearReserve && checkArrVal(tempFixSteps).length) {
                notification.warn({
                    message: '区间值的最大值需要大于最小值',
                });
                return;
            }
            const ruleData = {
                id: state.id,
                basePriceRemind: Number(state.overReserve),
                nearBasePriceRemind: Number(state.nearReserve),
                nearBasePriceStep: tempFixSteps,
            };
            Api.auction.saveReserveTipsRule(ruleData).then((res) => {
                this.getReserveTipsRule({}).then(() => {
                    notification.success({
                        message: '保存成功',
                    });
                });
            });
        },
        // 取消
        cancelReserveTips(payload, { state, update }) {
            this.getReserveTipsRule({});
        },
    },
});
